"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-37691522"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "required-calendar" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "pb-10" }, "週ごとに設定", -1 /* HOISTED */));
const _hoisted_3 = { class: "role-calendar-wrapper" };
const _hoisted_4 = { class: "weekdays-row" };
const _hoisted_5 = { class: "role-calendar-container" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "chip role-template-chip" };
const _hoisted_8 = { class: "repeat-infinity-icon" };
const _hoisted_9 = { class: "role-template-name" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "pb-10" }, "月ごとに設定", -1 /* HOISTED */));
const _hoisted_11 = { class: "role-calendar-wrapper" };
const _hoisted_12 = { class: "weekdays-row" };
const _hoisted_13 = { class: "role-calendar-container" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "date-num" };
const _hoisted_16 = {
    key: 0,
    class: "repeat-infinity-icon"
};
const _hoisted_17 = { class: "role-template-name" };
const vue_3 = require("vue");
const dateIntToKanji_1 = require("../../common/dateIntToKanji");
const dateInt_1 = __importDefault(require("../../common/dateInt"));
const japanesePublicHolidays_1 = __importDefault(require("../../common/japanesePublicHolidays"));
const RequiredCalendarNav_vue_1 = __importDefault(require("./RequiredCalendarNav.vue"));
const common_1 = require("../../common/common");
const timeZones_1 = __importDefault(require("../../common/timeZones"));
const InfinityIcon_vue_1 = __importDefault(require("../../assets/icons/InfinityIcon.vue"));
const roleSectionInjectionKeys_1 = require("../types/roleSectionInjectionKeys");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SectionRequiredCalendar',
    emits: ["emit-calendar-week-index", "emit-calendar-cell-date"],
    setup(__props, { emit: __emit }) {
        const templateStore = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewTemplateStore, undefined);
        const data = (0, vue_3.ref)({
            selectedDate: new Date()
        });
        const emits = __emit;
        const templateMapByWeekIndex = (0, vue_3.computed)(() => {
            const templateByWeekIdx = Array.from({ length: 7 }, () => ([]));
            if (templateStore) {
                templateStore.value.query().forEach(t => {
                    t.getRepeatedWeekDays().forEach((boolVal, i) => {
                        if (boolVal) {
                            if (!templateByWeekIdx[i].length) {
                                templateByWeekIdx[i] = [];
                            }
                            templateByWeekIdx[i].push(t.getId());
                        }
                    });
                });
            }
            return templateByWeekIdx;
        });
        const templateMapBySkipDays = (0, vue_3.computed)(() => {
            const map = {};
            if (templateStore) {
                templateStore.value.query().forEach(t => {
                    const skipDays = t.getSkipDays();
                    skipDays.forEach(d => {
                        const dateStr = (0, common_1.yearMonthDateString)(new Date(d), timeZones_1.default.ASIA_TOKYO);
                        if (!map[dateStr]) {
                            map[dateStr] = [];
                        }
                        map[dateStr].push(t.getId());
                    });
                });
            }
            return map;
        });
        const weekDaysIndex = (0, vue_3.computed)(() => {
            const keyNums = Object.keys(dateIntToKanji_1.intToJapaneseWeekdayKanji);
            const weekDayObj = [];
            keyNums.forEach((n, i) => {
                weekDayObj.push({
                    text: dateIntToKanji_1.intToJapaneseWeekdayKanji[parseInt(n)],
                    styleClass: '',
                });
                if (n == String(dateInt_1.default.SUN)) {
                    weekDayObj[i].styleClass = 'th-holiday';
                }
                if (n == String(dateInt_1.default.SAT)) {
                    weekDayObj[i].styleClass = 'th-saturday';
                }
            });
            return weekDayObj;
        });
        const selectedMonth = (0, vue_3.computed)(() => {
            return data.value.selectedDate.getMonth();
        });
        const selectedYear = (0, vue_3.computed)(() => {
            return data.value.selectedDate.getFullYear();
        });
        const todayDateStr = (0, vue_3.computed)(() => {
            return (0, common_1.yearMonthDateString)(new Date(), timeZones_1.default.ASIA_TOKYO);
        });
        const calendarDates = (0, vue_3.computed)(() => {
            const dates = [];
            const date = new Date(selectedYear.value, selectedMonth.value);
            const firstDayOfWeek = date.getDay();
            for (let i = 0; i < firstDayOfWeek; i++) {
                dates.push({
                    dateStr: '',
                    styleClass: 'empty-cell'
                });
            }
            while (date.getMonth() === selectedMonth.value) {
                const dateStr = (0, common_1.yearMonthDateString)(date, timeZones_1.default.ASIA_TOKYO);
                const realDate = new Date(date);
                const isDateHoliday = japanesePublicHolidays_1.default[dateStr] || date.getDay() === dateInt_1.default.SUN;
                const isSaturday = date.getDay() === dateInt_1.default.SAT;
                const isToday = todayDateStr.value === dateStr;
                const dateObj = {
                    dateStr: dateStr,
                    weekDayIndex: date.getDay(),
                    date: date.getDate(),
                    realDate: new Date(realDate),
                    styleClass: '',
                };
                if (isSaturday) {
                    dateObj.styleClass = 'th-saturday';
                }
                if (isDateHoliday) {
                    dateObj.styleClass = 'th-holiday';
                }
                if (isToday) {
                    dateObj.styleClass = 'today-text-num';
                }
                dates.push(dateObj);
                date.setDate(date.getDate() + 1); // Move to the next day
            }
            const remainingDaysInWeek = (-dates.length % 7 + 7) % 7;
            for (let i = 0; i < remainingDaysInWeek; i++) {
                dates.push({
                    dateStr: '',
                    styleClass: 'empty-cell'
                });
            }
            return dates;
        });
        const templateMapByDate = (0, vue_3.computed)(() => {
            return calendarDates.value.reduce((acc, d) => {
                if (!d.dateStr) {
                    return acc;
                }
                const templatesFiltered = templateStore?.value.query({ assignedDate: d.realDate }).map(t => t.getId()) || [];
                const weekDayIndex = d.weekDayIndex;
                let repeatTempIds = [];
                if (weekDayIndex !== undefined) {
                    repeatTempIds = templateMapByWeekIndex.value[weekDayIndex];
                }
                acc[d.dateStr] = templatesFiltered;
                repeatTempIds.forEach(rId => {
                    if (d.dateStr) {
                        const skippedTemplateIds = templateMapBySkipDays.value[d.dateStr] || [];
                        if (!templatesFiltered.includes(rId) && !skippedTemplateIds.includes(rId)) {
                            acc[d.dateStr].push(rId);
                        }
                    }
                });
                return acc;
            }, {});
        });
        function handleWeeklyCellClick(weekIndex) {
            const templatesInCell = templateMapByWeekIndex.value[weekIndex];
            const emitData = {
                dateStr: '',
                weekIndex: weekIndex,
                templateIds: templatesInCell
            };
            emits("emit-calendar-week-index", emitData);
        }
        function handleCalendarCellClick(date) {
            let templatesInCell = [];
            if (date?.dateStr) {
                templatesInCell = templateMapByDate.value[date.dateStr];
            }
            const emitData = {
                weekIndex: date.weekDayIndex || -1,
                templateIds: templatesInCell,
                dateStr: date.dateStr,
            };
            emits("emit-calendar-cell-date", emitData);
        }
        function isRepeatTemplate(templateId, date) {
            return Boolean(templateStore?.value.byId(templateId)?.isRepeatTemplate(date));
        }
        function templateName(templateId) {
            return templateStore?.value.byId(templateId)?.name;
        }
        function handleSelectedDate(emittedDate) {
            data.value.selectedDate = emittedDate;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(RequiredCalendarNav_vue_1.default, {
                    onEmitSelectedDate: handleSelectedDate,
                    "selected-date": data.value.selectedDate
                }, null, 8 /* PROPS */, ["selected-date"]),
                (0, vue_2.createCommentVNode)(" Weekly "),
                _hoisted_2,
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(weekDaysIndex.value, (weekDay) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                class: (0, vue_2.normalizeClass)(weekDay.styleClass)
                            }, (0, vue_2.toDisplayString)(weekDay.text), 3 /* TEXT, CLASS */));
                        }), 256 /* UNKEYED_FRAGMENT */))
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(weekDaysIndex.value, (_, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                class: "role-calendar-cell week-cell",
                                onClick: ($event) => (handleWeeklyCellClick(index))
                            }, [
                                (0, vue_2.createCommentVNode)(" Templates here "),
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(templateMapByWeekIndex.value[index], (templateId, idx) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_7, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_8, [
                                            (0, vue_2.createVNode)(InfinityIcon_vue_1.default)
                                        ]),
                                        (0, vue_2.createElementVNode)("span", _hoisted_9, (0, vue_2.toDisplayString)(templateName(templateId)), 1 /* TEXT */)
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ], 8 /* PROPS */, _hoisted_6));
                        }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                ]),
                _hoisted_10,
                (0, vue_2.createElementVNode)("div", _hoisted_11, [
                    (0, vue_2.createCommentVNode)(" Monthly "),
                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(weekDaysIndex.value, (weekDay) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                class: (0, vue_2.normalizeClass)(weekDay.styleClass)
                            }, (0, vue_2.toDisplayString)(weekDay.text), 3 /* TEXT, CLASS */));
                        }), 256 /* UNKEYED_FRAGMENT */))
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_13, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(calendarDates.value, (date, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                class: (0, vue_2.normalizeClass)(["role-calendar-cell", date.styleClass]),
                                key: `${date.dateStr}-${index}`,
                                onClick: ($event) => (handleCalendarCellClick(date))
                            }, [
                                (0, vue_2.createElementVNode)("span", _hoisted_15, (0, vue_2.toDisplayString)(date.date), 1 /* TEXT */),
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(templateMapByDate.value[date.dateStr], (templateId, index) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: `${templateId}-${index}`,
                                        class: "chip role-template-chip"
                                    }, [
                                        (isRepeatTemplate(templateId, new Date(date.dateStr)))
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_16, [
                                                (0, vue_2.createVNode)(InfinityIcon_vue_1.default)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("v-if", true),
                                        (0, vue_2.createElementVNode)("span", _hoisted_17, (0, vue_2.toDisplayString)(templateName(templateId)), 1 /* TEXT */)
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ], 10 /* CLASS, PROPS */, _hoisted_14));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ]));
        };
    }
});
